import React from 'react';
import { volumes } from '../data/breakFreeContent';
export function VolumesSection() {
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby="volumes-title" data-id="element-182" data-mp="3uuniv4pezkim">
      <div className="mx-auto max-w-5xl px-5" data-id="element-183" data-mp="cng40levbfa0">
        <h2 id="volumes-title" className="text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-184" data-mp="cm52ks8wajm2">
          The 6 volumes
        </h2>

        <ol className="mt-8 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-185" data-mp="3c3w9i35ffu48">
          {volumes.map(v => <li key={v.number} className="border border-charcoal-600 bg-charcoal-800 px-5 py-5" data-id="element-186" data-mp="3pvkme8ni2mm9">
              <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-champagne" data-id="element-187" data-mp="3l2rhnks17ea6">
                {v.number}
              </p>
              <h3 className="mt-1.5 font-display text-lg font-semibold uppercase leading-tight text-ivory-50" data-id="element-188" data-mp="2sfn6sz69c5qh">
                {v.title}
              </h3>
              <p className="mt-2 text-[14px] leading-snug text-body" data-id="element-189" data-mp="29ez49y5ngk1a">{v.line}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}